import React from 'react';

const Home: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      ❤️Shalini❤️
    </div>
  );
};

export default Home;
